<template>
  <authentic-modal ref="companyUsersModal" id="company-users-modal" size="lg" :title="modalTitle" :hide-footer="true">
    <company-users-list :fields="fields" :action-title="t('user_management.add_new_user')" :has-search="true">
    </company-users-list>
  </authentic-modal>
</template>

<script setup lang="ts">
  import AuthenticModal from "../shared/AuthenticModal.vue";
  import CompanyUsersList from "./CompanyUsersList.vue";
  import { onBeforeMount, ref, inject, onBeforeUnmount } from "vue";
  import { useI18n } from "vue-i18n";

  const companyUsersModal = ref<typeof AuthenticModal>();
  const { t } = useI18n();

  const emitter: any = inject("emitter");

  const modalTitle = t('user_management.title');

  const fields = [
    { key: "name", tdClass: "align-middle" },
    { key: "email", class: "limit-column-width", tdClass: "align-middle" },
    { key: "role", tdClass: "align-middle" },
    {
      key: "status",
      tdClass: ["align-middle", "text-center"],
      thClass: "text-center",
    },
    { key: "action", label: "", tdClass: "align-middle" },
  ];

  onBeforeMount(() => {
    emitter.on("user-management", async () => {
      companyUsersModal.value?.showModal();
    });
    emitter.on("user-management-close", async () => {
      companyUsersModal.value?.hideModal();
    });
  });

  onBeforeUnmount(() => {
    emitter.off("user-management");
  });

</script>

<style scoped></style>
